import React from 'react';
import styled from 'styled-components';
import { testId } from '@lojinha/helpers';
import { tabNavigationStyle } from '../../../helpers/tabNavigationStyle';
import { Button } from './button';
import { Pagination } from './pagination';
export const Container = styled.div `
  display: flex;
  align-items: center;
  width: 100%;

  ${tabNavigationStyle};

  ${({ positionX }) => {
    if (positionX === 'left')
        return `
      justify-content: flex-start;
      `;
    if (positionX === 'right')
        return `
        justify-content: flex-end;
      `;
    return ` justify-content: center;`;
}}
`;
export const Controls = ({ direction, id, onNextButtonClick, onPrevButtonClick, totalPagination, activePage, }) => {
    if (totalPagination <= 1)
        return null;
    const prevArrowDisabled = activePage === 0;
    const nextArrowDisabled = activePage === totalPagination - 1;
    return (React.createElement(Container, { "aria-controls": id, positionX: direction, className: "carousel-controls", ...testId('carousel-controls') },
        React.createElement(Button, { navigation: "prev", dataId: id, disabled: prevArrowDisabled, onClick: onPrevButtonClick }),
        React.createElement(Pagination, { activePage: activePage, totalPagination: totalPagination }),
        React.createElement(Button, { navigation: "next", dataId: id, disabled: nextArrowDisabled, onClick: onNextButtonClick })));
};
//# sourceMappingURL=index.js.map